interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const MessagesIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.3337 5.20866V9.45864C18.3337 10.517 17.9837 11.4087 17.3587 12.0253C16.742 12.6503 15.8503 13.0003 14.792 13.0003V14.5086C14.792 15.0753 14.1587 15.417 13.692 15.1003L12.8837 14.567C12.9587 14.3086 12.992 14.0253 12.992 13.7253V10.3337C12.992 8.63368 11.8587 7.50033 10.1587 7.50033H4.50032C4.38365 7.50033 4.27533 7.50867 4.16699 7.51701V5.20866C4.16699 3.08366 5.58366 1.66699 7.70866 1.66699H14.792C16.917 1.66699 18.3337 3.08366 18.3337 5.20866Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                />
                <path
                    d="M12.992 10.3334V13.725C12.992 14.025 12.9587 14.3083 12.8837 14.5667C12.5753 15.7917 11.5587 16.5583 10.1587 16.5583H7.89199L5.37532 18.2333C5.00032 18.4917 4.50032 18.2167 4.50032 17.7667V16.5583C3.65032 16.5583 2.94199 16.275 2.45033 15.7833C1.95033 15.2833 1.66699 14.575 1.66699 13.725V10.3334C1.66699 8.75002 2.65033 7.65835 4.16699 7.51668C4.27533 7.50835 4.38365 7.5 4.50032 7.5H10.1587C11.8587 7.5 12.992 8.63335 12.992 10.3334Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                />
            </svg>
        </span>
    );
};

export default MessagesIcon;
